import { render, staticRenderFns } from "./TranscriptionSpeaker.vue?vue&type=template&id=0c2505a7"
import script from "./TranscriptionSpeaker.vue?vue&type=script&lang=js"
export * from "./TranscriptionSpeaker.vue?vue&type=script&lang=js"
import style0 from "./TranscriptionSpeaker.vue?vue&type=style&index=0&id=0c2505a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports